import Image from 'next/image'

import { CopyrightText } from '@/components/copyright-text'

import { GuardianLayout } from '../guardian'

interface LoginLayoutProps {
  children: React.ReactNode
}

export const LoginLayout = (props: LoginLayoutProps): JSX.Element => {
  return (
    <GuardianLayout>
      <main className="flex h-screen flex-col bg-basic-bg">
        <header className="flex h-[50px] items-center bg-white px-2.5 md:h-[60px] md:px-[18px] lg:h-[70px]">
          <Image
            src="/sged-logo.svg"
            width={78}
            height={30}
            className="md:h-[45px] md:w-[117px]"
            alt="Sony Global Education"
          />
        </header>
        <div className="grow">{props.children}</div>
        <footer className="mt-auto py-3.5">
          <p className="text-center text-[10px] font-medium text-secondary-93 md:text-xs">
            <CopyrightText />
          </p>
        </footer>
      </main>
    </GuardianLayout>
  )
}
